"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const TABS = [
  { href: "/explore/tokens", label: "Tokens" },
  { href: "/explore/pools", label: "V3 Pools" },
  { href: "/explore/v2-pools", label: "V2 Pools" },
  { href: "/explore/transactions", label: "Transactions" },
];

export function ExploreTabs() {
  const pathname = usePathname();

  return (
    <div className="mx-auto mt-4 mb-4 flex w-fit flex-wrap justify-center gap-1 rounded-2xl bg-muted p-1">
      {TABS.map((t) => {
        const active = pathname === t.href;
        return (
          <Link
            key={t.href}
            href={t.href}
            className={
              "rounded-xl px-3 py-2 text-sm font-medium whitespace-nowrap transition-all sm:px-4 " +
              (active ? "bg-background text-foreground shadow-sm" : "text-foreground/60 hover:text-foreground")
            }
          >
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}
